import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { PATHS } from 'src/common/constants';
import {
  useServiceRequestAPI,
  UseServiceRequestAPIReturn,
} from 'src/pages/ServiceRequest/CustomHooks/useServiceRequestAPI';
import { SidebarContextRow } from '../Components/SidebarContextTree';

interface RouteParams {
  id: string;
}

const useServiceRequestContextRows = (): SidebarContextRow[] | null => {
  const match = useRouteMatch<RouteParams>({
    path: PATHS.SERVICE_REQUESTS_VIEW,
  });
  const serviceRequestId: string = match?.params?.id ?? '';

  const {
    serviceRequest,
    fetchServiceRequestById,
  }: UseServiceRequestAPIReturn = useServiceRequestAPI();

  useEffect(() => {
    if (!serviceRequestId) {
      return;
    }

    fetchServiceRequestById(serviceRequestId);
  }, [serviceRequestId]);

  if (!match || !serviceRequestId) {
    return null;
  }

  const ticketNumber: string | null =
    serviceRequest?.ticketNumber ?? serviceRequest?.ticketId ?? null;

  return [
    {
      label: ticketNumber ?? '',
      path: PATHS.SERVICE_REQUESTS_VIEW.replace(':id', serviceRequestId),
      icon: 'wrench',
      loading: ticketNumber === null,
    },
  ];
};

export default useServiceRequestContextRows;
